import DropdownMenuComponent from './ui-components/DropdownMenuComponent';
import { supportedLanguagesWithVoices } from 'flow/types/CreateSoundTypes';

interface Props {
    languageCode: string;
    onLanguageChange: (languageCode: string) => void;
    voice: string;
    onVoiceChange: (voice: string) => void;
    availableVoices: Array<{ id: string; gender: string }>;
    disabled?: boolean;
}

const LanguageVoiceSelector = ({
    languageCode,
    onLanguageChange,
    voice,
    onVoiceChange,
    availableVoices,
    disabled = false,
}: Props) => {
    const currentLanguage = supportedLanguagesWithVoices.find(
        (lang) => lang.code === languageCode,
    );

    return (
        <div className="flex gap-4">
            <DropdownMenuComponent
                anchor="top start"
                title={currentLanguage?.name || ''}
                className="max-w-1/2 flex-1"
                disabled={disabled}
                onItemSelected={onLanguageChange}
                options={supportedLanguagesWithVoices.map((lang) => ({
                    key: lang.code,
                    label: lang.name,
                }))}
            />
            <DropdownMenuComponent
                anchor="top start"
                title={voice}
                className="max-w-1/2 flex-1"
                disabled={disabled}
                onItemSelected={onVoiceChange}
                options={availableVoices.map((voice) => ({
                    key: voice.id,
                    label: `${voice.id} (${voice.gender})`,
                }))}
            />
        </div>
    );
};

export default LanguageVoiceSelector;
